module.exports = {"langUnavailable":{"title":"Cette page n'est pas disponible dans votre langue.","body":"Souhaitez-vous poursuivre la navigation ou revenir à la page d'accueil ?","dismiss":"Fermer cette alerte et poursuivre la navigation","close":"Fermer","navigate":"Page d'accueil"},"langRecommendation":{"title":"Votre langue de préférence est l'Français. Voulez-vous visiter le site en Français?","navigate":"Oui","close":"Non"}}


//////////////////
// WEBPACK FOOTER
// ./scripts/routes/translations/fr.json
// module id = 82
// module chunks = 0